var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "Select",
        {
          staticStyle: { width: "100%" },
          attrs: {
            placeholder: "Tags",
            value: _vm.value,
            multiple: "",
            "max-tag-count": 4,
            size: _vm.size
          },
          on: { "on-select": _vm.onSelect }
        },
        _vm._l(_vm.$store.state.interest_setting, function(item, key) {
          return _c(
            "OptionGroup",
            { key: key, attrs: { label: _vm.$t("" + key) } },
            _vm._l(item.data, function(i) {
              return _c("Option", { key: i.key, attrs: { value: i.key } }, [
                _vm._v(_vm._s(_vm.$t("preferences_setting." + i.key)))
              ])
            }),
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-018a1299", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-018a1299","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/interest_tag_select/index.vue
// module id = null
// module chunks = 